import { THEME_TYPE, IParams } from 'interfaces';
import { AGE_IMAGE_VARIANT, GENDER, SURVEY_CONFIG } from 'types';

export const DEFAULT_PARAMS: IParams = {
	config: SURVEY_CONFIG.DEFAULT_CONFIG,
	gender: GENDER.FEMALE,
	theme: THEME_TYPE.LIGHT,
	utm_source: undefined,
	force_lang: undefined,
	ageStepScreen: AGE_IMAGE_VARIANT.A,
	startPage: undefined,
	mailDescriptionV2: false,
	pauseOnLoaderPage: true,
	isSkipResultPage: false,
	resultPage0day: false,
	resultPagePlansTable: false,
	emailStepWithGift: false,
};
